//@ts-nocheck
import React from "react";
import moment from "moment";
import { diffrenceInDatesCheck, formatNextDayTime ,splitFromCapital} from "../bookingConfirmation/Utils/CommenFunction";
import {get} from "lodash";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
function timeConvert(n) {
  let number = n;
  let hours = number / 60;
  let rhours = Math.floor(hours);
  let minutes = (hours - rhours) * 60;
  let rminutes = Math.round(minutes);
  return (number = rhours + "h " + rminutes + "m");
}

function FlightDetailsTab(props) {


  let fareBasisDetails = props.paxFare &&
    props.paxFare[0] &&
    props.paxFare[0].fareBasisDetails


  let segmentData =  props.data && Object.values(props.data)[0] && Object.values(props.data)[0]
  let layovers =segmentData && segmentData.layovers;
  let flights =segmentData && segmentData.flights;
  let flightDuration = segmentData && segmentData.durationMinutes;

  let layoverTime = 0;
  let flightTime = 0;
  
  return (
    <>
      {flights &&
        flights.map((flight, index) => {

          let arrivalDate = flight.arrivalDateTime
          let dapartureDate = flight.departureDateTime
          let diffrenceInDates = diffrenceInDatesCheck(dapartureDate,arrivalDate); 
      
          let brandedFareDetails = fareBasisDetails && fareBasisDetails.filter(flightId => flightId.flightId === flight.id)
          let brandedFareName = brandedFareDetails &&
            brandedFareDetails[0] &&
            brandedFareDetails[0].brand &&
            brandedFareDetails[0].brand.brandName
          let brandedFareCode = brandedFareDetails &&
            brandedFareDetails[0] &&
            brandedFareDetails[0].brand &&
            brandedFareDetails[0].brand.code
          let num = timeConvert(flight.durationMin);
          let integerValue = parseInt(flight.durationMin);
          flightTime += integerValue
          
          let depdateTime = moment.utc(flight.departureDateTime).format("HH:mm");
          let classOfService = brandedFareDetails && brandedFareDetails[0] && brandedFareDetails[0].classOfService
          
          return (
            <div key={flight.id}>

              <div className="flight_tabs_hader">
                <div className="row head">
                  <div className="flight_tabs-left">
                    <div className="text_title">
                      <span>
                        
                        {flight.carrierName !== undefined ? flight.carrierName : flight.airlineName}{" "} 
                        {flight.carrier} {flight.number} {classOfService}
                      </span>
                      {flight.cabin == undefined ?
                        <span>
                        (
                        {get(brandedFareDetails?.[0], "cabin", "") === "PremiumEconomy" ? "Premium Economy" : get(brandedFareDetails?.[0], "cabin", "")}
                        )
                      </span>
                      :
                      <span>
                        (
                        {flight.cabin === "PremiumEconomy" ? "Premium Economy" : flight.cabin}
                        )
                      </span>
                      }
                    </div>
                  </div>
                  <div className="flight_tabs-right">


                   
                    
                  {brandedFareCode !== undefined ?
                    <OverlayTrigger
                      trigger="hover"
                      placement="top"
                      delay={{ show: 100 }}
                      overlay={
                        <Popover className="seatView-popover">
                        <div className="seatView-popover-row seatView-popover-amount">
                            Brand Code : {brandedFareCode}
                          </div>
                        </Popover>
                      }
                    >
                      {brandedFareName !== undefined && <div className="fareOption">Fare Option: {brandedFareName} </div>}
                    </OverlayTrigger> : brandedFareName !== undefined && <div className="fareOption">Fare Option: {brandedFareName}</div>}


                  </div>
                </div>
                <div className="row flight_tabs-side">

                   <span>
                      {" "}
                      {flight.operatingCarrier && "Operated by: " + flight.operatingAirlineName + " (" + flight.operatingCarrier + ")"}  {flight && flight.aircraftDescription ? "|" + flight.aircraftDescription : ""}
                    </span>

                  <div className="ml-3">
                    {flight && flight.aircraftNoOfSeats &&
                      <span>Seats: {flight.aircraftNoOfSeats}</span>
                    }

                  </div>
                </div>
              </div>



              <div className="f-details-senction">
                <div className="f-details-col">
                  <div className="fd-name-time">
                    {flight && flight.departureAirportCity} ({flight && flight.departureAirport})<br />
                    <span>{depdateTime}</span>
                  </div>
                  {flight.departureTerminal !== undefined ? (
                    <span className="fd-aireport-detail">
                      {"Terminal " + flight.departureTerminal}
                    </span>
                  ) : (
                    <span className="fd-aireport-detail">
                      {"Terminal " + " -"}
                    </span>
                  )}
                </div>
                <div className="fd-time">
                  {num} <i className="far fa-clock"></i>
                </div>
                <div className="f-details-col">
                  <div className="fd-name-time">
                    {flight && flight.arrivalAirportCity} ({flight && flight.arrivalAirport})<br />
                    {/* <span>{formatNextDayTime(flight.departureDateTime, flight.arrivalDateTime)}</span> */}
                    {diffrenceInDates !== 0 ? <span> {moment.utc(flight.arrivalDateTime).format("HH:mm")} <sup className="text-danger">{Number(diffrenceInDates) > 0 ? "+" + diffrenceInDates : diffrenceInDates}</sup> </span> : <span> {moment.utc(flight.arrivalDateTime).format("HH:mm")}</span>}
                  </div>
                  {flight && flight.arrivalTerminal !== undefined ? (
                    <span className="fd-aireport-detail">
                      {"Terminal " + flight.arrivalTerminal}
                    </span>
                  ) : (
                    <span className="fd-aireport-detail">
                      {"Terminal " + " -"}
                    </span>
                  )}
                </div>
              </div>
              {layovers && layovers[index] ? (
                <div className="f-DetailsLayover">
                  <div className="f-DetailsLayoverTitle">

                    <span className="f-DetailsLayoverTym">
                      {timeConvert(layovers[index].durationMinutes)}{" "}
                    </span>
                    {"Layover in " + flight.arrivalAirport}
                  </div>
                </div>
              ) : null}

              {flights && flights.length - 1 === index ? (
                <div className="fd-total-time">
                  <div>
                    Total Flight Time
                    <span>
                      <i className="far fa-clock"></i>
                      {timeConvert(flightTime)}
                    </span>
                  </div>
                  {layovers && layovers.map(value => {
                    layoverTime += value.durationMinutes
                  })}
                  <div>
                    Total Trip Duration
                    <span>
                      <i className="far fa-clock"></i>{timeConvert(flightDuration)}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          );
        })}
    </>
  );
}

export default FlightDetailsTab;
